module.exports = __webpack_public_path__ + "img/125.4d49afb1.jpg";